import React from 'react';
import ModalFormUI from '../../../widgets/form/ModalFormUI';
import InputTextSF from '../../../widgets/form/InputTextSF';
import InputSelectSF from '../../../widgets/form/InputSelectSF';
const UpdateEmailModalUI = ({
  // Modes
  context, successMsg, errorList, setErrorList, submitted,
  updateEmailMode,
  // Event Handlers
  onSubmit, onCancelClick,
  // Email
  email, onEmailChange, emailError, setEmailError,
}) => {

  return (
    <ModalFormUI
      context={context}
      titleLabel='Add Email'
      buttonLabel="Add"
      cancelLabel="Cancel"
      isOpen={updateEmailMode}
      onRequestClose={onCancelClick}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={submitted}
    >

      <InputTextSF type="text" name="email" label="Email"
        maxLength={40} required={true}
        value={email} onChange={onEmailChange}
        error={emailError} setError={setEmailError}
      />
    </ModalFormUI>
  );
};

export default UpdateEmailModalUI;
